(function () {
  'use strict';

  angular
    .module('biReport', ['safetyModule']);
}());
